import { Image } from 'react-native';
import styled from 'styled-components/native';

export const CardFlagImage = styled(Image)`
  height: 24px;
`;
